import {
  Typography,
  List,
  ListItem,
} from "@mui/material";

const Formula = () => {
  return (
    <>
      <List disablePadding
        sx={{
          ".MuiListItem-root": {
            paddingX: "4px !important",
            paddingY: "8px !important",
          },
        }}
      >
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>Sales</strong>{" "}
            = Sales quantity during analysis period (including OTP).
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>Stock</strong>{" "}
            = Current Stock.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Maximum SKU
            </strong>{" "}
            = Maximum SKU quantity allowed to send to branch.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Pending Qty
            </strong>{" "}
            = Pending order/order issued which is not received.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Group Consumption
            </strong>{" "}
            = Sales quantity during analysis period ÷ Number of analysis days.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Lead Days Sales
            </strong>{" "}
            = Expected sales quantity during lead days (Consumption × Lead
            days).
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Excess/Short During Lead days
            </strong>{" "}
            = Stock quantity (if negative, consider as zero) − Lead Days sales.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Excess Qty During Lead days
            </strong>{" "}
            = Excess stock quantity after Lead days sales.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Required Qty for Forecast Days
            </strong>{" "}
            = Group Consumption × Forecast Days.
          </Typography>
        </ListItem>
        <ListItem>
          <Typography>
            •{" "}
            <strong style={{ fontWeight: 600, color: "#0d73bb" }}>
              Required Qty
            </strong>{" "}
            = Required Qty for Forecast Days − Excess Qty During Lead days −
            Pending Qty (if negative, consider as zero).
          </Typography>
        </ListItem>
      </List>
    </>
  );
};

export default Formula;
